export default {
  expired: 'expired',
  error: 'error',
  noLogin: 'noLogin',
  iamTokenExpired: 'iamTokenExpired',
  accountDeleted: 'accountDeleted'
};
